import { render, staticRenderFns } from "./AdminTemplate.vue?vue&type=template&id=bdf4c93a&scoped=true"
import script from "./AdminTemplate.vue?vue&type=script&lang=js"
export * from "./AdminTemplate.vue?vue&type=script&lang=js"
import style0 from "./AdminTemplate.vue?vue&type=style&index=0&id=bdf4c93a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf4c93a",
  null
  
)

export default component.exports